// @flow

import * as React from "react";

import type { Template } from "../../templates/";

import "./ConfidenceLabels.css";

type Props = {
  template: Template
};

const ConfidenceLabels = (props: Props) => (
  <div className="ConfidenceLabels">
    <span className="ConfidenceLabels-Label ConfidenceLabels-Left">
      {props.template.task.confidenceLabels.left}
    </span>
    <span className="ConfidenceLabels-Label ConfidenceLabels-Middle">
      {props.template.task.confidenceLabels.middle}
    </span>
    <span className="ConfidenceLabels-Label ConfidenceLabels-Right">
      {props.template.task.confidenceLabels.right}
    </span>
  </div>
);

export default ConfidenceLabels;



// WEBPACK FOOTER //
// ./src/components/ConfidenceLabels/ConfidenceLabels.js